import { Component, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, inject, signal } from '@angular/core';
import { MatMenuTrigger } from "@angular/material/menu";
import { NotificationRecord, NotificationService } from 'src/app/utility/services/notification/notification.service';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { Subscription, Observable, isObservable } from 'rxjs';

@Component({
  selector: 'app-notification-history',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatIconModule, MatDividerModule, MatButtonModule, MatTableModule],
  templateUrl: './notification-history.component.html',
  styleUrls: ['./notification-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationHistoryComponent implements OnDestroy {
  @ViewChild(MatMenuTrigger) trigger?: MatMenuTrigger;

  items = signal<NotificationRecord[]>([]);
  history$ = inject(NotificationService).history$;

  displayedColumns: string[] = ['icon', 'message', 'time'];

  private notif = inject(NotificationService);
  private sub?: Subscription;

  constructor(private cd: ChangeDetectorRef) {
    try {
      this.items.set(this.notif.history());
    } catch {
      this.items.set([]);
    }


    if (this.history$) {
      this.sub = this.history$.subscribe((v: NotificationRecord[] | any) => {
        const next = Array.isArray(v) ? v : (typeof (this.notif as any).history === 'function' ? (this.notif as any).history() : []);
        this.items.set(next);
        this.cd.markForCheck();
      });
    }
  }

  refresh() {
    try {
      this.items.set(this.notif.history());
      this.cd.markForCheck();
    } catch { /* ignore */ }
  }

  clear(event?: MouseEvent) {
    event?.stopPropagation();
    this.notif.clearHistory();
    this.items.set([]);
    this.trigger?.closeMenu();
    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  iconFor(t: NotificationRecord['type']) {
    switch (t) {
      case 'error': return 'error';
      case 'warning': return 'warning';
      case 'info': return 'info';
      default: return 'check_circle';
    }
  }
}
